export default function(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
}



//////////////////
// WEBPACK FOOTER
// ./~/topojson/~/topojson-client/src/reverse.js
// module id = 539
// module chunks = 0